import orderTypeModule from "./orderTypeModule"
import orderTypeView from "./orderTypeView.html"

orderTypeModule.config(["editionServiceProvider", (editionServiceProvider) => {
    editionServiceProvider.registerEdition("order-type", orderTypeView, "orderTypeController")
}])